import { RootState } from 'redux/store';
import { BaseApiLegalCorporationConfig } from 'services/api/legalCorporationConfig/types';

export const getLegalCorporationConfig = (
  rootState: RootState,
): BaseApiLegalCorporationConfig | null => {
  return rootState.legalCorporation.legalCorporationConfig;
};

export const isPaymentEnabled = (rootState: RootState): boolean => {
  return rootState.legalCorporation.legalCorporationConfig?.isPaymentEnabled ?? false;
};

export const isPaymentCutoffEnabled = (rootState: RootState): boolean => {
  return rootState.legalCorporation.legalCorporationConfig?.isPaymentCutoffEnabled ?? false;
};

export const getAllowedPaymentMethods = (rootState: RootState): string[] => {
  return (
    rootState.legalCorporation.legalCorporationConfig?.paymentConfiguration
      ?.allowed_payment_methods ?? []
  );
};

export const isAccountBalanceEnabled = (rootState: RootState): boolean => {
  return (
    rootState.legalCorporation.legalCorporationConfig?.tabConfiguration?.show_account_balance ??
    true
  );
};

export const isInvoiceTabEnabled = (rootState: RootState): boolean => {
  return rootState.legalCorporation.legalCorporationConfig?.tabConfiguration?.show_invoices ?? true;
};

export const isDeliveryNoteTabEnabled = (rootState: RootState): boolean => {
  return (
    rootState.legalCorporation.legalCorporationConfig?.tabConfiguration?.show_delivery_notes ?? true
  );
};

export const getAccountBalanceAgingBasedOn = (rootState: RootState): string | null => {
  return (
    rootState.legalCorporation.legalCorporationConfig?.accountBalanceConfiguration
      ?.aging_date_basis ?? null
  );
};
